import { useQuery } from '@tanstack/react-query';
import { preRegistrationApi } from '../api/pre-registration.api';
import { preRegistrationKeys } from './usePreRegistrationQueries';

// Municipality catalog (63 items, loaded by SQL): cache it for the session
export const useMunicipalities = (departmentId?: number) => {
  return useQuery({
    queryKey: preRegistrationKeys.municipalities(departmentId),
    queryFn: () => preRegistrationApi.getMunicipalities(departmentId),
    staleTime: Infinity,
  });
};
